export enum ECommandResult {
  SUCCESS = 0,
  ERROR = 1,
  ALERT = 2
}

export interface ICommandResult<T> {
  status: ECommandResult;
  message: string;
  errorCode?: string;
  result?: T;
}